<template>
  <div>
    <div v-if="cancelPenalty.deadline" :class="displayMessageClass" class="is-size-7 my-2">
      {{ displayMessage }}
    </div>
    <div v-if="showText && cancelPenalty.text" class="is-size-7 my-2 has-text-grey">
      {{ cancelPenalty.text.join("\n\r") }}
    </div>
  </div>
</template>

<script>

  var moment = require('moment');

  export default {
  components: {

  },
  props: {
    cancelPenalty: {},
    showText: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    penaltyAmount() {
      let displayAmount = 'Free'

      if (this.cancelPenalty.amount) {
        displayAmount = this.cancelPenalty.amount

        if (this.cancelPenalty.currencyCode) {
          if (this.cancelPenalty.currencyCode != 'USD') {
            displayAmount = this.cancelPenalty.amount + ' ' + this.cancelPenalty.currencyCode

          } else {
            displayAmount = '$' + this.cancelPenalty.amount
            //displayAmount = this.$options.filters.formatPriceFromAmount(this.cancelPenalty.amount)
          }
        }

        if (this.convertedDisplayAmount) {
          displayAmount = displayAmount + ' (approx. ' + this.convertedDisplayAmount + ')'
        }
      } else if (this.cancelPenalty.percent) {
        displayAmount = this.cancelPenalty.percent + '%'
      } else if (this.cancelPenalty.numberOfNightsPenalty) {
        displayAmount = this.cancelPenalty.numberOfNightsPenalty + ' nights'
      }

      return displayAmount
    },
    requestedCurrencyCode(){
      if(this.cancelPenalty.converted){
        return this.cancelPenalty.converted.currencyCode
      } else {
        return null
      }
    },
    convertedDisplayAmount(){
      if (this.cancelPenalty.converted) {
        return this.cancelPenalty.converted.amount + ' ' + this.cancelPenalty.converted.currencyCode
      } else {
        return null
      }
    },
    displayMessage() {
      let message = ''
      let deadline = 'deadline in cancellation policy'

      if (this.cancelPenalty.deadline) {
        deadline = moment.parseZone(this.cancelPenalty.deadline).format('ddd, MMM D [at] h:mma');
      }

      // A. Non refundable
      
      // C. Link "Check cancellation conditions" when it is unknown
      if (!this.cancelPenalty) {
        message = 'Check cancellation conditions'
      }
      
      // Ex 1: Cancel by Thursday, January 27, 2022 23:59 local hotel time to avoid a charge of 277.59 USD
      if (this.cancelPenalty.amount || this.cancelPenalty.percent || this.cancelPenalty.numberOfNightsPenalty) {
        message = 'Cancel by ' + deadline + ' to avoid a charge of ' + this.penaltyAmount
      } else {
        // Ex 2: Free cancellation until Tue, Jan 18, 2022 - Help text: This rate can be canceled free of charge until the date specified
        message = 'FREE cancellation until ' + deadline
      }

      return message
    },
    displayMessageClass() {
      if (this.cancelPenalty.amount || this.cancelPenalty.percent || this.cancelPenalty.numberOfNightsPenalty) {
        return 'has-text-danger'
        // return ''
      } 

      return 'has-text-success'
    }
  },
  methods: {
  },
}

</script>

<style scoped>

</style>
